import { createApp } from "vue";
import { router } from "./router";
import App from "./App.vue";
import VueCookies from 'vue-cookies'
import winnerApi from "./util/winnerApi";
import configs from "./config/configs";
import apis from "./util/apis";

const app = createApp(App);
app.use(router);
app.use(VueCookies);

app.config.globalProperties.winnerApi = winnerApi
app.config.globalProperties.configs = window.app_configs = configs
app.config.globalProperties.apis = apis;

app.mount("#app");
